import {
  showErrorNotification,
  showInfoNotification,
  showSuccessNotification,
  showWarningNotification,
} from '../model';
import type { Notification } from '../types';

export const initNotifications = () => {
  (window as any).showSuccessNotification = (notification: Notification) => {
    showSuccessNotification({
      title: notification.title,
      label: notification.label,
      action: notification.action,
      code: notification.code,
    });
  };

  (window as any).showInfoNotification = (notification: Notification) => {
    showInfoNotification({
      title: notification.title,
      label: notification.label,
      action: notification.action,
      code: notification.code,
    });
  };

  (window as any).showWarningNotification = (notification: Notification) => {
    showWarningNotification({
      title: notification.title,
      label: notification.label,
      action: notification.action,
      code: notification.code,
    });
  };

  (window as any).showErrorNotification = (notification: Notification) => {
    showErrorNotification({
      title: notification.title,
      label: notification.label,
      action: notification.action,
      code: notification.code,
    });
  };
};

initNotifications();
